import { DEFAULT_LANGUAGE, LocalizedText } from 'apollo/localizedTypes';

const isEmptyText = (value?: string | null): boolean => !value || !value.trim();

const requiredDefaultLanguage = (
  message: string,
  isEmpty: (value?: string | null) => boolean = isEmptyText
) => ({
  message,
  validator: (rule: unknown, value: unknown): Promise<void> => {
    const localizedText = value as LocalizedText | undefined;
    if (!isEmpty(localizedText?.[DEFAULT_LANGUAGE])) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(message));
  },
});

export default requiredDefaultLanguage;
